import { useSelector } from 'react-redux';
import { selectUserInfo } from 'store/auth/selectors';
import { CurrentDomacareUser } from 'types/AuthRequired';

const useUser = (): CurrentDomacareUser => useSelector(selectUserInfo()).currentDomacareUser;

export default useUser;
